import { render, staticRenderFns } from "./pondRecovery.vue?vue&type=template&id=1c637151&scoped=true"
import script from "./pondRecovery.vue?vue&type=script&lang=js"
export * from "./pondRecovery.vue?vue&type=script&lang=js"
import style0 from "./pondRecovery.vue?vue&type=style&index=0&id=1c637151&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c637151",
  null
  
)

export default component.exports